// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"g5-z","sponsoredTooltipWrapper":"h5-z","sponsoredTooltip":"i5-z","newCard":"j5-z"};